module.exports = __webpack_public_path__ + "static/media/my.c1870604.jpeg";